/**
 * Admin Pages Index
 * 
 * Centralized exports for all admin-related pages.
 * All implementations are organized in their respective subfolders.
 * 
 * Structure:
 *   BatchJobs/          - Job orchestration & scheduling management
 *   BrokerManagement/   - Broker platform management (add, edit, delete brokers)
 *   BrokerPriority/     - Broker priority configuration
 *   InstrumentMaster/   - Instrument data management & reconciliation
 *   LiveConnections/    - WebSocket connection monitoring
 *   Models/             - Read-only model registry (superuser-only, 142-9)
 *   TradeEconomics/     - Append-only charge schedule + broker commissions (superuser-only, 144-6)
 *   UserRoles/          - User role management & role definitions
 */

// Main admin pages
export { default as BatchJobs } from './BatchJobs/BatchJobs';
export { default as LiveConnections } from './LiveConnections/LiveConnections';
export { default as InstrumentMaster } from './InstrumentMaster/InstrumentMaster';
export { default as UserRoleManagement } from './UserRoles/UserRoleManagement';
export { default as RoleDefine } from './UserRoles/RoleDefine';
export { default as BrokerPriorityConfig } from './BrokerPriority/BrokerPriorityConfig';
export { default as BrokerManagement } from './BrokerManagement/BrokerManagement';
export { default as MarketDataManagement } from './MarketDataManagement/MarketDataManagement';
// 142-9 — read-only model registry page (superuser-only).
export { default as ModelsPage } from './Models/ModelsPage';
// 144-6 — trade-economics schedule admin (statutory charges + broker commissions; superuser-only).
export { default as TradeEconomicsPage } from './TradeEconomics/TradeEconomicsPage';
// 104 Element R (D67/R12.3) — admin backup recovery panel (secondary to the
// user-facing /StuckOrders screen).
export { default as AdminRecoveryPanel } from './SelfServiceRecovery/AdminRecoveryPanel';

// Reconciliation pages (nested under InstrumentMaster)
export { default as ReconciliationDashboard } from './InstrumentMaster/Reconciliation/ReconciliationDashboard';
export { default as ReconciliationDetail } from './InstrumentMaster/Reconciliation/ReconciliationDetail';
